import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck } from 'lucide-react';
export function Guarantee() {
  return <section className="py-20 px-4 bg-brand-darker" data-id="element-117">
      <div className="max-w-3xl mx-auto" data-id="element-118">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-gradient-to-br from-brand-primary/10 to-brand-dark border border-brand-primary/30 rounded-3xl p-8 md:p-12 text-center relative overflow-hidden" data-id="element-119">
          <div className="absolute -right-10 -top-10 text-brand-primary/5" data-id="element-120">
            <ShieldCheck className="w-64 h-64" data-id="element-121" />
          </div>

          <div className="relative z-10" data-id="element-122">
            <ShieldCheck className="w-16 h-16 text-brand-gold mx-auto mb-6" data-id="element-123" />
            <h2 className="text-3xl md:text-4xl font-serif text-brand-cream-light mb-6" data-id="element-124">
              GARANTÍA 7 DÍAS — SIN PREGUNTAS
            </h2>

            <div className="space-y-4 text-lg text-brand-cream mb-8" data-id="element-125">
              <p data-id="element-126">Abrís los tomos. Aplicás los protocolos.</p>
              <p data-id="element-127">
                Si en 7 días no es lo que esperabas → devolución del 100% sin
                formularios, sin drama.
              </p>
            </div>

            <div className="inline-block bg-brand-darker px-6 py-3 rounded-full border border-brand-primary/20" data-id="element-128">
              <p className="text-brand-accent font-medium" data-id="element-129">
                Tasa de devoluciones: menos del 1%.
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}